export interface ChatMessage {
  id: string;
  type: 'user' | 'ai';
  content: string;
  timestamp: string;
}

export const chatHistory: ChatMessage[] = [
  {
    id: '1',
    type: 'ai',
    content: "Hi! I'm AIQ, your contract intelligence assistant. I can help you understand terms, suggest improvements, and answer questions about your agreement.",
    timestamp: '10:30 AM'
  },
  {
    id: '2',
    type: 'user',
    content: "What's the typical advance percentage for a recording contract?",
    timestamp: '10:31 AM'
  },
  {
    id: '3',
    type: 'ai',
    content: "Recording advances typically range from 50-85% of estimated royalties. For new artists, 60-70% is common. Your current setting of 70% is within industry standard. Consider your recoupment timeline when negotiating.",
    timestamp: '10:31 AM'
  },
  {
    id: '4',
    type: 'user',
    content: "Should I be concerned about the 2-year contract term?",
    timestamp: '10:33 AM'
  },
  {
    id: '5',
    type: 'ai',
    content: "2 years is actually quite reasonable for a first recording contract. Many labels prefer 3-5 year terms. This gives you flexibility to renegotiate sooner if your career takes off. Make sure there are clear performance milestones.",
    timestamp: '10:33 AM'
  },
  {
    id: '6',
    type: 'user',
    content: "What about the royalty rate? Is 15% good?",
    timestamp: '10:35 AM'
  },
  {
    id: '7',
    type: 'ai',
    content: "15% is on the lower end for established artists but acceptable for newer artists. Industry standard ranges from 12-20%. Consider negotiating escalations based on sales milestones - e.g., 15% for first 100k units, 17% thereafter.",
    timestamp: '10:35 AM'
  }
];